"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var localization_1 = require("../utils/localization");

var localization_2 = require("../constants/localization");

var Localization = function () {
  function Localization(config) {
    if (config === void 0) {
      config = {};
    }

    this.supportedLanguages = localization_2.supportedLanguages;
    var whitelistLanguageIds = lodash_1.isArray(config.includedIds) ? config.includedIds : [];
    var filteredLanguageIds = lodash_1.isArray(config.excludedIds) ? config.excludedIds : [];
    var ls = typeof localStorage === 'undefined' ? {} : localStorage;
    var unfilteredIds = (lodash_1.invoke(ls, 'getItem', 'unfilteredLocales') || '').split(',');

    if (whitelistLanguageIds.length) {
      whitelistLanguageIds = whitelistLanguageIds.map(function (id) {
        return localization_1.default.getLanguageId(id);
      });

      if (unfilteredIds.length) {
        unfilteredIds.forEach(function (id) {
          var languageId = localization_1.default.getLanguageId(id);

          if (!whitelistLanguageIds.includes(languageId)) {
            whitelistLanguageIds.push(languageId);
          }
        });
      }

      this.supportedLanguages = this.supportedLanguages.filter(function (option) {
        return whitelistLanguageIds.includes(option.id);
      });
    }

    if (filteredLanguageIds.length) {
      filteredLanguageIds = filteredLanguageIds.map(function (id) {
        return localization_1.default.getLanguageId(id);
      });

      if (unfilteredIds.length) {
        filteredLanguageIds = lodash_1.reject(filteredLanguageIds, function (id) {
          return unfilteredIds.includes(id);
        });
      }

      this.supportedLanguages = lodash_1.reject(this.supportedLanguages, function (option) {
        return filteredLanguageIds.includes(option.id);
      });
    }

    var languageId = localization_1.default.getLanguageId(config.id, this.supportedLanguages);
    this.selectedLocale = localization_1.default.getLanguageObj(languageId);
  }

  Object.defineProperty(Localization.prototype, "cookieCompliance", {
    get: function get() {
      var languageId = lodash_1.get(this.selectedLocale, 'id');
      return localization_1.default.getCookieCompliance(languageId);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "helpPage", {
    get: function get() {
      var languageId = lodash_1.get(this.selectedLocale, 'id');
      return localization_1.default.getHelpPage(languageId);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "helpPageGuest", {
    get: function get() {
      var languageId = lodash_1.get(this.selectedLocale, 'id');
      return localization_1.default.getHelpPageGuest(languageId);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "language", {
    get: function get() {
      return lodash_1.get(this.selectedLocale, 'language');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "languageDisplayName", {
    get: function get() {
      return lodash_1.get(this.selectedLocale, 'displayName');
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "languageId", {
    get: function get() {
      return lodash_1.get(this.selectedLocale, 'id');
    },
    set: function set(id) {
      var languageId = localization_1.default.getLanguageId(id, this.supportedLanguages);
      this.selectedLocale = localization_1.default.getLanguageObj(languageId);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "languageOptions", {
    get: function get() {
      var _this = this;

      return localization_1.default.getLanguageOptions().filter(function (option) {
        return !!_this.supportedLanguages.find(function (language) {
          return language.id === option.id;
        });
      });
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "privacyPolicy", {
    get: function get() {
      var languageId = lodash_1.get(this.selectedLocale, 'id');
      return localization_1.default.getPrivacyPolicy(languageId);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "termsOfService", {
    get: function get() {
      var languageId = lodash_1.get(this.selectedLocale, 'id');
      return localization_1.default.getTermsOfService(languageId);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Localization.prototype, "locale", {
    get: function get() {
      return this.selectedLocale;
    },
    enumerable: true,
    configurable: true
  });
  return Localization;
}();

exports.default = Localization;